function getDialogProps() {
  return {
    ...((window.innerWidth < 480 || window.innerHeight < 480) && {
      fullScreen: true,
    }),
    slotProps: {
      paper: {
        style: {
          paddingBottom: `env(safe-area-inset-bottom)`,
        },
      },
    },
  };
}

export default getDialogProps;
